import { useCallback } from "react";
import { CommandButtonGroup } from "@remirror/react-ui";
import { ToggleDropdownButtonParams } from "../../../types";
import { FontSizeButtons, TextColorButtons } from "./TextFormattingButtons";

interface TextFormattingButtonGroupProps {
  toolbarRef: React.RefObject<HTMLDivElement>;
  onBlur: () => void;
}

export const TextFormattingButtonGroup: React.FC<
  TextFormattingButtonGroupProps
> = ({ toolbarRef, onBlur }) => {
  const findButtonByAriaLabel = useCallback(
    (ariaLabel: string) => {
      if (toolbarRef.current) {
        return toolbarRef.current.querySelector<HTMLButtonElement>(
          `button[aria-label="${ariaLabel}"]`,
        );
      }
      return null;
    },
    [toolbarRef],
  );

  // Custom way to add the selected styling to match the other toggle buttons
  const toggleDropdownButton = useCallback(
    ({ shouldSelect, ariaLabel }: ToggleDropdownButtonParams) => {
      const button = findButtonByAriaLabel(ariaLabel);
      if (button) {
        if (shouldSelect) {
          button.classList.add("custom-dropdown-button-selected");
        } else {
          button.classList.remove("custom-dropdown-button-selected");
        }
      }
    },
    [findButtonByAriaLabel],
  );

  return (
    <CommandButtonGroup>
      <TextColorButtons toggleButton={toggleDropdownButton} onBlur={onBlur} />
      <FontSizeButtons toggleButton={toggleDropdownButton} onBlur={onBlur} />
    </CommandButtonGroup>
  );
};
